import { render, staticRenderFns } from "./user-recharge.vue?vue&type=template&id=3766a97e&scoped=true"
import script from "./user-recharge.vue?vue&type=script&lang=js"
export * from "./user-recharge.vue?vue&type=script&lang=js"
import style0 from "./user-recharge.vue?vue&type=style&index=0&id=3766a97e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766a97e",
  null
  
)

export default component.exports